export default "__VITE_ASSET__73af6522__"